export default "__VITE_ASSET__CwT4Xbrm__"